import React, { Component } from "react";
import { navigate } from "gatsby";

import Swiper from "../../../components/swiper";
import ModuleWrapper from "../../../components/moduleWrapper";
import Image from "../../../components/image";
import Breadcrumbs from "../../../components/breadCrumbs";

import SearchModal from "../components/searchModal";
import Ratings from "../../../components/ratings/ratings";

import SearchTopBar from "../components/searchTopBar";
import Description from "../components/description";
import LodgingTabs from "../components/lodgingTabs";
import GalleryModal from "../components/galleryModal";
import Seo from "../../../components/seo";

import { getLanguageField } from "../../../utils/language";
import { getQuery } from "../../../utils/query";
import { differenceInDays } from "../../../utils/datefns";
import getAvailability, { parseFormFromQueryString, processForm, getSearchFormConfiguration } from "../../../services/lodging";
import Pricing from "../../../components/pricing";
import RoomSummarySelection from "../../../components/roomSummarySelection";
import { gtmFunction } from "../../../utils/gtm";
// import Select from "../../../components/select";
import { isRunTime } from "../../../utils/isRunTime";
import provisionalModuleDataBasedOnLanguage from "./provisionalModuleDataBasedOnLanguage";
import Location from "./components/location";
import Amenities from "./components/amenities";
import Units from "./components/units";
import Policies from "./components/policies";
import MapModal from "./components/portals/mapModal";
import SearchForm from "./components/form/searchForm";
import HeadStyling from "src/layouts/components/styling/head.styling";

const { getSupplierSlug } = require("../../../../build-helpers/create-page");

export default class SupplierPage extends Component {
  state = {
    loading: false,
    currentTab: 0,
    searchDrawer: false,
    mapModal: false,
    photosModal: false,
    form: {
      arrivalDate: null,
      departureDate: null,
      guests: []
    },
    orderPrice: "ASC",
    units: this.props.pageContext.supplier.products,
    unavailableUnits: [],
    fromPrice: 0,
    currentRoom: undefined,
    numberOfRooms: undefined,
    noSearch: true,
    errorOnSearch: false
  }

  supplier = this.props.pageContext.supplier;
  language = this.props.pageContext.language
  colors = {
    formPrimaryColor: this.props.pageContext.supplier?.secondary_color?.value,
    formSecondaryColor: this.props.pageContext.supplier?.primary_color?.value
  }
  primaryButtonStyle = `bg-[color:var(--primaryColor)] border-none text-[color:var(--secondaryColor)]`
  secondaryButtonStyle = `bg-white border-[color:var(--secondaryColor)] text-[color:var(--primaryColor)]`

  moduleData = provisionalModuleDataBasedOnLanguage(this.language)

  componentDidMount() {
    const query = getQuery();
    if ( (query.startdate && query.enddate && query.adult) || ((this.supplier.type === "activity" || this.supplier.type === "restaurant") && query.startdate)) {
      let { guests, arrivalDate, departureDate } = parseFormFromQueryString(query);
      if (guests && !Array.isArray(guests[0])) guests = [guests];
      this.setState({
        form: {
          ...this.state.form,
          guests,
          arrivalDate,
          departureDate
        },
        currentRoom: query.currentRoom,
        numberOfRooms: query.numberOfRooms,
        noSearch: false
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.form !== prevState.form) {
      this.updateAvailability();
    }
  }

  orderUnits(units, orderValue){
    const newUnits = [...units];
    newUnits.sort((a, b) => {
      if(orderValue === "DESC"){
        if(a.product_uuid.price[0].amount < b.product_uuid.price[0].amount) return 1;
        if(a.product_uuid.price[0].amount > b.product_uuid.price[0].amount) return -1;
        return 0
      }
      else {
        if(a.product_uuid.price[0].amount > b.product_uuid.price[0].amount) return 1;
        if(a.product_uuid.price[0].amount < b.product_uuid.price[0].amount) return -1;
        return 0
      }
    })

    return newUnits;
  }

  updateAvailability = () => {
    this.setState({ loading: true, noSearch: false, errorOnSearch: false });
    getAvailability({ form: {...this.state.form, guests: this.state.currentRoom ? this.state.form.guests[this.state.currentRoom - 1] : this.state.form.guests[0] }, supplierId: this.supplier.uuid, type: this.supplier.type })
    .then(res => {
      if (res && res.response && res.status === "ok") {
        const newUnavailableUnits = [];
        const { prices, from_price } = res.response;
        const updatedUnits = this.props.pageContext.supplier.products.map(unit => {
          const availability = prices?.find(result => {
            return result.id === parseInt(unit.product_uuid.integration_uuid)
          });
          if (availability && (this.state.numberOfRooms <= availability.available || !this.state.numberOfRooms) ) {
            availability.price = availability.price.map(price => {
              return {
                ...price,
                amount: availability.selected_services ? price.amount += availability.selected_services.reduce((total, service) => total + service.price.price_value, 0) : price.amount
              }
            })
            let services = []
            if (this.supplier.products && this.supplier.products[0] && this.supplier.products[0].product_uuid.services) {
              this.supplier.products[0].product_uuid.services.forEach(service => {
                const thisServiceOnAvailability = availability.optional_services?.find(serv => { return serv.product_id === parseInt(service.service_uuid.integration_uuid) })
                if (thisServiceOnAvailability) {
                  services.push({
                    ...thisServiceOnAvailability,
                    maxQuantity: service.max_quantity | thisServiceOnAvailability.quantity,
                    quantity: 0,
                    ...service.service_uuid
                  })
                }
              })
            }
            return {
              ...unit,
              product_uuid: {
                ...unit.product_uuid,
                availability: availability.steps,
                price: availability.price,
                requirements: availability.requirements,
                selected_services: availability.selected_services,
                services
              }
            };
          }
          if(this.supplier.type === "activity") return undefined
          return {
            ...unit,
            product_uuid: {
              ...unit.product_uuid,
              availability: false,
            }
          };
        }).filter(unit => {
          if(unit === undefined) return false;
          if(!unit.product_uuid.availability){
            let newUnit = {...unit};
            newUnavailableUnits.push(newUnit);
            return false;
          }
          return true;
        })
        const sortedUnits = this.orderUnits(updatedUnits, this.state.orderPrice);
        this.setState({
          units: sortedUnits,
          unavailableUnits: newUnavailableUnits,
          fromPrice: from_price,
          loading: false,
        }, () => {
          const unitsToSend = sortedUnits.map(unit => { return { ...unit.product_uuid, id: unit.product_uuid.uuid }});
          gtmFunction("view_item_list", unitsToSend);
          this.forceUpdate();
        })
      } else if (!res || res.status === "error") {
        this.setState({
          loading: false,
          errorOnSearch: true
        })
      }
    });
  }

  changeTab = (tab) => {
    this.setState({ currentTab: tab });
  }

  toggleSearchDrawer = () => {
    this.setState({ searchDrawer: !this.state.searchDrawer })
  }

  toggleMapModal = () => {
    this.setState({ mapModal: !this.state.mapModal })
  }

  togglePhotosModal = () => {
    this.setState({ photosModal: !this.state.photosModal });
  }

  filterOrderChange = (value) => {
    const orderedUnits = this.orderUnits(this.state.units, value);
    this.setState({orderPrice: value, units: orderedUnits})
  }

  navigateToProductPage = (index) => {
    const { translations = [], type = "" } = this.state.units.concat(this.state.unavailableUnits)[index]?.product_uuid;
    let linkToSupplierPage = `/${getSupplierSlug(this.supplier.destination.default_language.code, this.language, type, translations.find(translation => translation.language.code === this.language).slug)}`;
    if (window.location.search) {
      linkToSupplierPage += window.location.search;
    }
    const unitToSend = this.state.units.concat(this.state.unavailableUnits)[index]?.product_uuid;
    gtmFunction("select_item", [unitToSend])
    navigate(linkToSupplierPage);
  }

  updateDatesAndGuests = (arrivalDate = "", departureDate = "", guests = [], numberOfRooms) => {
    const searchParams = new URLSearchParams(window.location.search);
    const processedForm = processForm({ departureDate, arrivalDate, guests });
    for (const [key, value] of Object.entries(processedForm)) {
      if(key === "arrivalDate" && value) searchParams.set("startdate", value)
      if(key === "departureDate" && value) searchParams.set("enddate", value)
      if (key === "guests" && value) {
        if (Array.isArray(value)) {
          if (!processedForm.childages) searchParams.set("adult", value.join("-"));
          else {
            const adultString = value.map((val, index) => {
              if (processedForm.childages[index]) return val - processedForm.childages[index].split(",").length;
              return val;
            })
            searchParams.set("adult", adultString.join("-"))
          }
        } else {
          if(!processedForm.childages) searchParams.set("adult", value);
          else searchParams.set("adult", value - processedForm.childages.split(",").length);
        }
      }
      if(key === "childages") {
        if (Array.isArray(value)) {
          searchParams.set("childages", value.join("-") || "");
        } else {
          searchParams.set("childages", value || "");
        }
      }
    }
    if (numberOfRooms) searchParams.set("numberOfRooms", numberOfRooms);
    if (!searchParams.get("currentRoom") && numberOfRooms) searchParams.set("currentRoom", 1);
    const newSearch = searchParams.toString().replace("%2C", ",");
    const newUrl = `${window.location.pathname}?${newSearch}`;
    window.history.replaceState(null, '', newUrl)
    this.setState({
      searchDrawer: false,
      form: {
        arrivalDate,
        departureDate,
        guests
      },
      numberOfRooms,
      currentRoom: numberOfRooms ? 1 : undefined
    })
  }

  getNumberOfPersons = () => {
    if (!this.state.currentRoom) return 0;
    let persons = this.state.form.guests[this.state.currentRoom - 1].length;
    return persons;
  }

  getNumberOfGuests = () => {
    let numberOfGuests = 0;
    if(this.state.numberOfRooms > 1){
      this.state.form.guests.forEach(guest => {
        numberOfGuests += guest.length
      })
    }
    else {
      numberOfGuests = this.state.form.guests.length ? this.state.form.guests[0].length : 0;
    }
    return numberOfGuests;
  }

  getTabsBySupplierType = (type) => {
    const lodgingTabs = [this.moduleData.roomsLabel, this.moduleData.descriptionLabel, this.moduleData.amenitiesLabel, this.moduleData.locationLabel, this.moduleData.policiesLabel];
    const activityTabs = [this.moduleData.activitiesLabel, this.moduleData.descriptionLabel, this.moduleData.locationLabel, this.moduleData.policiesLabel];
    const restaurantTabs = [this.moduleData.restaurantLabel, this.moduleData.descriptionLabel, this.moduleData.locationLabel, this.moduleData.policiesLabel];
    if (type === "activity") return activityTabs;
    if (type === "restaurant") return restaurantTabs;
    return lodgingTabs;
  }

  getMinDate = () => {
    if (this.supplier.products.length === 1 && this.supplier.products[0].product_uuid.book_type_min_anticipation) {
      const minAnticipationDays = this.supplier.products[0].product_uuid.book_type_min_anticipation;
      const minDate = new Date();
      minDate.setDate(minDate.getDate() + minAnticipationDays);
      return minDate;
    }
    return new Date();
  };

  render() {
    const { state, toggleSearchDrawer, toggleMapModal, changeTab, primaryButtonStyle, secondaryButtonStyle, supplier, language, togglePhotosModal, navigateToProductPage, getTabsBySupplierType, getMinDate } = this;
    const { loading, form, units, searchDrawer, mapModal, currentTab, photosModal, numberOfRooms, noSearch } = state;

    const address = this.props?.pageContext?.supplier?.location?.address || ""
    const name = getLanguageField(supplier.translations, language, 'name');
    const totalNights = form.arrivalDate && form.departureDate ? differenceInDays(form.arrivalDate, form.departureDate) : 0
    const persons = this.getNumberOfPersons();
    const numberOfGuests = this.getNumberOfGuests();
    const { max_adults, max_junior, max_stay, min_adults, min_junior, min_stay, junior_min_age, junior_max_age, blocked_days, blackout_periods, max_guests, translations, messaging } = getSearchFormConfiguration(supplier);

    return (
      <ModuleWrapper className={`relative bg-gray-100 font-manrope`}>
        <main id="supplierPage" className={"max-w-7xl mx-auto lg:pt-4 min-h-screen"}>
            <div className="bg-white rounded-t-2xl p-4 pb-0">
              <Breadcrumbs pages={[{name: this.moduleData.searchResultLabel, current: false}, { name: getLanguageField(supplier?.translations, language, "name"), current: true}]}/>
            </div>
            {!noSearch
              ?
              <div className="lg:hidden sticky top-14 z-10 px-4 bg-white">
                <SearchTopBar name={name} type={supplier.type} arrivalDate={form.arrivalDate} departureDate={form.departureDate} guests={numberOfGuests} onEditSearch={toggleSearchDrawer} selectedLanguage={language} rooms={this.state.numberOfRooms}/>
              </div>
              :
              <div id="mobileForm" className="lg:hidden bg-white">
                
                <SearchForm
                  minDate={getMinDate()}
                  maxGuests={max_guests}
                  searchFormTranslations={translations}
                  buttonStyles={primaryButtonStyle}
                  language={language}
                  arrivalDate={form.arrivalDate}
                  departureDate={form.departureDate}
                  guests={form.guests}
                  type={supplier.type}
                  loading={loading}
                  _numberOfRooms={numberOfRooms}
                  multiRoom={supplier.activate_multiple_room}
                  maxRooms={supplier.max_multiple_rooms}
                  onSearch={(_startDate, _endDate, _guests, numberOfRooms) => {
                    this.updateDatesAndGuests(_startDate, _endDate, _guests, numberOfRooms);
                  }}
                  minStay={min_stay}
                  maxStay={max_stay}
                  guestsTypes={{
                    min_adults,
                    min_junior,
                    max_adults,
                    max_junior,
                    junior_max_age,
                    junior_min_age
                  }}
                  weekDaysBlocked={blocked_days ? blocked_days : []}
                  blackoutPeriods={blackout_periods ? blackout_periods : []}
                  messaging={messaging}
                  errorOnSearch={this.state.errorOnSearch}
                />
              </div>
            }
          <div className="relative p-6 rounded-2xl bg-white rounded-t-none pt-0">
            <Swiper
              width={null}
              arrowClassName=""
              className="w-full h-64 lg:h-96 rounded-2xl"
              navigation={true}
              customNavigation
              customNavigationPrevClassName="absolute left-4 text-white bg-opacity-80 bg-black p-1 rounded-full z-[9] my-auto top-[108px] lg:top-[165px]"
              customNavigationNextClassName="absolute right-4 text-white bg-opacity-80 bg-black p-1 rounded-full z-[9] my-auto top-[108px] lg:top-[165px]"
              slidesPerView={1}
              spaceBetween={0}
              autoplay={false}
              onClick={togglePhotosModal}
            >
              {
                supplier.images
                .sort((a,b) => a.position - b.position)
                .filter(file => file.image)
                .map((file) => {
                  return <Image className="w-full h-full object-cover" src={`https://public-assets.spotliodata.com/${file.image.filename_disk}`} />
                })
              }
            </Swiper>
            <button
              className={`absolute bottom-10 right-10 z-[1] px-3 py-2 font-semibold text-sm rounded-lg min-w-max text-[color:var(--secondaryColor)] bg-[color:var(--primaryColor)]`}
              onClick={togglePhotosModal}
            >
               {this.moduleData.buttonOpenGalleryViewLabel} {supplier.images.length} {this.moduleData.buttonOpenGalleryPicturesLabel}
            </button>
          </div>
          <div className="lg:flex lg:gap-4 lg:py-4">
            <section id="supplier" className="bg-white lg:w-8/12 rounded-2xl">
              {
                this.state.numberOfRooms > 1 ?
                  <div className="p-4">
                    <RoomSummarySelection
                      step={1}
                      persons={persons}
                      totalSteps={2}
                      nights={totalNights}
                      currentRoom={this.state.currentRoom}
                      language={this.language}
                    />
                  </div>
                : <div className="pt-6"/>
              }
              <header className="p-6 pb-0 flex pt-0 gap-2">
                <div className="flex flex-col font-semibold gap-2">
                    <h2 className="text-lg">{name}</h2>
                  <div className="text-gray-500 text-sm">{address}</div>
                </div>
                {this.state.fromPrice && this.state.fromPrice.amount ?
                  <span className="ml-auto">
                    <Pricing loading={loading} price={this.state.fromPrice} language={language}/>
                  </span>
                  : null
                }
                <Ratings ratings={supplier.rating_value} />
                {
                  supplier.rating_value ?
                  <div className="mt-4 flex items-center">
                    <span style={{ backgroundColor: "#6D62E4" }} className="w-8 font-bold text-base text-white px-2 py-1 rounded-lg">{supplier.rating_value}</span>
                    <span className="text-base pl-2">Excellent</span>
                    <span style={{ color: "#6D62E4" }} className="ml-auto block text-base">View all {supplier.rating_reviews} reviews</span>
                  </div>
                  : null
                }
              </header>
              {/* <div className="flex flex-col md:flex-row gap-2"> */}
                <LodgingTabs
                  currentTab={currentTab}
                  changeTab={changeTab}
                  primaryButtonStyle={secondaryButtonStyle}
                  baseURL={isRunTime() ? window.location.pathname : ""}
                  tabs={getTabsBySupplierType(supplier.type)}
                />
                  {/* get modal from supplier list */}
                {/* <div className="ml-auto flex gap-2 items-center">
                  Order by
                  <Select
                    onChange={(value) => this.filterOrderChange(value)}

                    selectedValue={this.state.orderPrice}
                    options={[
                      {
                        label: "ASC",
                      },
                      {
                        label: "DESC",
                      }
                    ]}
                  />
                </div> */}
              {/* </div> */}

              <div>
                <Units
                  date={form.arrivalDate}
                  noSearch={noSearch}
                  noResults={`${name} ${this.moduleData.noResultsLabel}`}
                  disabledText={this.moduleData.unavailableLabel}
                  title={this.moduleData.roomsLabel}
                  language={language}
                  supplier={supplier}
                  loading={loading}
                  units={units.concat(this.state.unavailableUnits)}
                  onCtaClick={navigateToProductPage}
                  ctaText={this.moduleData.unitButtonLabel}
                  buttonStyle={this.primaryButtonStyle}
                  secondaryButtonStyle={this.secondaryButtonStyle}
                />
               <div className="w-full h-[2px] bg-[#EAEAF2]" />
                <Description title={this.moduleData.descriptionLabel} description={getLanguageField(supplier.translations, language, 'description', true)} buttonStyle={this.secondaryButtonStyle} buttonOpenText={this.moduleData.showLessButtonLabel} buttonClosedText={this.moduleData.showMoreButtonLabel}/>
                <div className="w-full h-[2px] bg-[#EAEAF2]" />
                {
                  supplier.type !== "activity" && supplier.type !== "restaurant" ?
                  <>
                    <div className="p-6"><Amenities title={this.moduleData.amenitiesLabel} language={language} amenities={supplier.features} buttonStyle={this.secondaryButtonStyle} buttonOpenText={this.moduleData.showLessButtonLabel} buttonClosedText={this.moduleData.showAllButtonLabel} /></div>
                    <div className="w-full h-[2px] bg-[#EAEAF2]" />
                  </>
                  : null
                }
                {
                  supplier.location ?
                  <>
                    <Location title={this.moduleData.locationLabel} supplier={supplier} color={"#6D62E4"}/>
                    <div className="w-full h-[2px] bg-[#EAEAF2]" />
                  </>
                  : null
                }
                <Policies title={this.moduleData.policiesLabel} language={language} policies={supplier.policies} buttonStyle={this.secondaryButtonStyle} buttonOpenText={this.moduleData.showLessButtonLabel} buttonClosedText={this.moduleData.showMoreButtonLabel} />
              </div>
            </section>
            <aside id="sidebar" className={"hidden lg:flex lg:flex-col lg:w-4/12"}>
              <div id="form" className={"bg-white rounded-2xl"}>
                <SearchForm
                  minDate={getMinDate()}
                  maxGuests={max_guests}
                  searchFormTranslations={translations}
                  colors={this.colors}
                  buttonStyles={primaryButtonStyle}
                  language={language}
                  arrivalDate={form.arrivalDate}
                  departureDate={form.departureDate}
                  guests={form.guests}
                  type={supplier.type}
                  loading={loading}
                  _numberOfRooms={numberOfRooms}
                  multiRoom={supplier.activate_multiple_room}
                  maxRooms={supplier.max_multiple_rooms}
                  onSearch={(_startDate, _endDate, _guests, numberOfRooms) => {
                    this.updateDatesAndGuests(_startDate, _endDate, _guests, numberOfRooms);
                  }}
                  minStay={min_stay}
                  maxStay={max_stay}
                  guestsTypes={{
                    min_adults,
                    min_junior,
                    max_adults,
                    max_junior,
                    junior_max_age,
                    junior_min_age
                  }}
                  weekDaysBlocked={blocked_days ? blocked_days : []}
                  blackoutPeriods={blackout_periods ? blackout_periods : []}
                  messaging={messaging}
                  errorOnSearch={this.state.errorOnSearch}
                />
              </div>
            </aside>
          </div>
          <SearchModal
            selectedLanguage={language}
            arrivalDate={form.arrivalDate}
            departureDate={form.departureDate}
            guests={form.guests}
            open={searchDrawer}
            closeFn={toggleSearchDrawer}
            type={supplier.type}
            _numberOfRooms={numberOfRooms}
            multiRoom={supplier.activate_multiple_room}
            maxRooms={supplier.max_multiple_rooms}
            onSearch={(_startDate, _endDate, _guests, numberOfRooms) => {
              this.updateDatesAndGuests(_startDate, _endDate, _guests, numberOfRooms);
            }}
            minStay={min_stay}
            maxStay={max_stay}
            guestsTypes={{
              min_adults,
              min_junior,
              max_adults,
              max_junior,
              junior_max_age,
              junior_min_age
            }}
            weekDaysBlocked={blocked_days ? blocked_days : []}
            blackoutPeriods={blackout_periods ? blackout_periods : []}
            messaging={messaging}
            errorOnSearch={this.state.errorOnSearch}
          />
          <MapModal supplier={supplier} closeFn={() => toggleMapModal()} open={mapModal}/>
          <GalleryModal 
            closeFn={togglePhotosModal}
            images={supplier.images.filter(file => file.image)}
            open={photosModal}
            size="large"
            language={language}
          />
        </main>
      </ModuleWrapper>
    )
  }
}

export const Head = ({ pageContext }) => {
  //Valid tags inside the Head function are: link, meta, style, title, base, script, and noscript.
  return (<>
    <HeadStyling layout={pageContext.layout} />
    <Seo data={pageContext.supplier} pageContext={pageContext} />
  </>);
}